import { Code, Palette, Rocket } from 'lucide-react'
import type { ComponentType } from 'react'
import type { I18nKeys } from '@/shared/core/hooks/use-translation/use-translation.ts'

export interface SkillCardData {
	descriptionKey: I18nKeys
	exampleKeys: [I18nKeys, I18nKeys, I18nKeys]
	icon: ComponentType<{ className?: string }>
	id: string
	showcaseAltKey: I18nKeys
	showcaseImage: string
	titleKey: I18nKeys
}

export interface TechItem {
	color: string
	icon: ComponentType<{ className?: string }>
	id: string
	name: string
}

export interface TechCategory {
	id: string
	items: TechItem[]
	labelKey: I18nKeys
}

export const skillCards: SkillCardData[] = [
	{
		descriptionKey: 'portfolio.section.skills.card.design.description',
		exampleKeys: [
			'portfolio.section.skills.card.design.example1',
			'portfolio.section.skills.card.design.example2',
			'portfolio.section.skills.card.design.example3',
		],
		icon: Palette,
		id: 'design',
		showcaseAltKey: 'portfolio.section.skills.card.design.showcaseAlt',
		showcaseImage: '/images/skills/design-showcase.svg',
		titleKey: 'portfolio.section.skills.card.design.title',
	},
	{
		descriptionKey: 'portfolio.section.skills.card.code.description',
		exampleKeys: [
			'portfolio.section.skills.card.code.example1',
			'portfolio.section.skills.card.code.example2',
			'portfolio.section.skills.card.code.example3',
		],
		icon: Code,
		id: 'code',
		showcaseAltKey: 'portfolio.section.skills.card.code.showcaseAlt',
		showcaseImage: '/images/skills/code-showcase.svg',
		titleKey: 'portfolio.section.skills.card.code.title',
	},
	{
		descriptionKey: 'portfolio.section.skills.card.deploy.description',
		exampleKeys: [
			'portfolio.section.skills.card.deploy.example1',
			'portfolio.section.skills.card.deploy.example2',
			'portfolio.section.skills.card.deploy.example3',
		],
		icon: Rocket,
		id: 'deploy',
		showcaseAltKey: 'portfolio.section.skills.card.deploy.showcaseAlt',
		showcaseImage: '/images/skills/deploy-showcase.svg',
		titleKey: 'portfolio.section.skills.card.deploy.title',
	},
]
